import { createRouterTransport } from "@connectrpc/connect";
import { AccountService } from "schema/gen/es/chiikipoint/wallet/v2/account_service_connect.js";
import {
  GetTenantResponse,
  type LoginRequest,
  LoginResponse,
} from "schema/gen/es/chiikipoint/wallet/v2/account_service_pb.js";
import { getMockTenantByUrl } from "./config";
import { generateToken } from "./utils";

export const accountServiceMockTransport = createRouterTransport(
  ({ service }) => {
    service(AccountService, {
      getTenant: () => {
        const tenant = getMockTenantByUrl();
        return new GetTenantResponse({
          tenant: {
            ...tenant,
            id: "1",
            contact: "0120-1234-5678",
          },
        });
      },
      login: async (_: LoginRequest) =>
        new LoginResponse({
          token: await generateToken(),
        }),
    });
  },
  {
    transport: {
      interceptors: [
        (next) => async (req) => {
          // 通信遅延をシミュレート
          // await new Promise((resolve) => setTimeout(resolve, 200));
          return next(req);
        },
      ],
    },
  },
);
